import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.jsx';
import CompanyService from 'services/company2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import ExtendFields from 'components/extendFields';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import CommonFns from 'functions/common.ts';
import EnumService from 'services/enum2';

/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Forder%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

function OrderList(props) {
  const Config = {
    sale: {
      title: '客户订单列表',
      apiPath: '/customerPurchase/list',
      countApi: '/customerPurchase/count',
      countTransform: data => {
        //分类统计 [2交期差异待确认，1待答交, 3退回]
        let { 2: a, 1: b, 3: c } = data;
        setCount([undefined, a, b, c]);
      },
      orderProperty: 'po.erpPurchaseDate',
      arrEnumField: [
        {
          mainKey: 'B02_NCPo_Status',
          subKey: 'orderStatus',
          value: 'orderStatusName'
        },
        {
          mainKey: 'B02_CPo_Delivery_Status',
          subKey: 'deliveryStatus',
          value: 'deliveryStatusName'
        }
      ],
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/customer/order/detail',
      searchBarPlaceholder: '客户名称/编码、订单编号、商品名称/编码/规格',
      tabs: ['全部', '差异待处理', '待答交', '退回'],
      tabConfig: [
        [], //全部
        [2], //差异待处理
        [1, 10], //待答交
        [3] //退回
      ]
    },
    purchase: {
      title: '采购订单列表',
      apiPath: '/purchase/list',
      countApi: '/purchase/count',
      countTransform: data => {
        //分类统计 [2交期差异待确认，1待答交, 3退回]
        let { 2: a, 1: b, 3: c } = data;
        setCount([undefined, a, b, c]);
      },
      orderProperty: 'po.erpPurchaseDate',
      needSessionStorage: true,
      //枚举列表
      arrEnumField: [
        {
          mainKey: 'B02_NPo_Status',
          subKey: 'orderStatus',
          value: 'orderStatusName'
        },
        {
          mainKey: 'B02_Po_Receive_Status',
          subKey: 'receiveStatus',
          value: 'receiveStatusName'
        }
      ],
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/order/detail',
      searchBarPlaceholder: '供应商名称/编码、订单编号、商品名称/编码/规格',
      tabs: ['全部', '差异待处理', '待答交', '退回'],
      tabConfig: [
        [], //全部
        [2], //差异待处理
        [1, 10], //待答交
        [3] //退回
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  const [isOrderAutoPublish, setIsOrderAutoPublish] = useState(false);
  const [onlyShowUnPublish, setOnlyShowUnPublish] = useState(false);
  const [onlyMyself, setOnlyMyself] = useState(false);
  const [extendSearchParams, setExtendSearchParams] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerXkUniqueCode, setCustomerXkUniqueCode] = useState('');
  const [extendComapnyCode, setExtendComapnyCode] = useState('');
  const [dateQueryRangeTypeList, setDateQueryRangeTypeList] = useState([]);
  const [dateQueryRangeType, setDateQueryRangeType] = useState('1');

  //初始化默认企业
  useEffect(() => {
    self.init();
    EnumService.getList('B2b_OrderDate_QueryRangeType').then(data => {
      if (data.length > 0) {
        setDateQueryRangeTypeList(
          data.filter(item => !['99'].includes(item.subKey))
        );
      }
    });

    // 从记忆恢复快速过滤
    if (self.historyState?.searchQueries?.publishStatus === 0) {
      setOnlyShowUnPublish(true);
    }
    if (self.historyState?.searchQueries?.dataRange === 1) {
      setOnlyMyself(true);
    }
    // 从记忆恢复采购说明
    if (Array.isArray(self.historyState?.searchQueries?.extendSearchParams)) {
      setExtendSearchParams(
        self.historyState?.searchQueries?.extendSearchParams
      );
    }
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount({ dateQueryRangeType: dateQueryRangeType });
    //采购方, 此处必须判断系统参数是否开启了自动发送。
    if (self.isPurchase) {
      CompanyService.getCompanyParamsByCodes(
        companyCode,
        ['Order_Auto_Publish'],
        false
      ).then(rs => {
        if (rs.length > 0) {
          let paramValue = rs[0].paramValue.split(';');
          //6种类型订单均开启了自动发布时才隐藏过滤条件
          setIsOrderAutoPublish(paramValue.length === 8);
        }
      });
      setExtendComapnyCode(companyCode);
    }
  }, [companyCode, dateQueryRangeType, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search(true, 1);
  }, [
    searchKey,
    companyCode,
    currentTab,
    extendSearchParams,
    onlyShowUnPublish,
    onlyMyself,
    dateQueryRangeType,
    self
  ]);

  useEffect(() => {
    self.getCustomerList();
  }, [companyCode, self]);

  //扩展搜索参数
  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        publishStatus: onlyShowUnPublish ? 0 : undefined,
        // sourceSystem: onlyShowUnPublish ? 2 : undefined,
        // receiveStatus: currentTab === 2 ? [0] : undefined,
        dataRange: onlyMyself ? 1 : undefined
      };
    }
    self.searchQueries.orderStatus = config.tabConfig[currentTab];
    self.searchQueries.extendSearchParams = extendSearchParams;
    self.searchQueries.dateQueryRangeType = dateQueryRangeType;
  };

  self.getCustomerList = async function () {
    CompanyService.getCustomerList(companyCode, [2], 1, false).then(rs => {
      if (rs.length > 0) {
        setCustomerList(rs);
      }
    });
  };

  function handleCustomerChange(event) {
    let code = event.target.value;
    customerList.forEach(item => {
      if (item.customerCode === code) {
        setCustomerXkUniqueCode(item.id);
      }
    });
    setExtendComapnyCode(code);
  }

  function extendSeach(data) {
    handleReset();
    if (data.fieldValue === '') {
      setExtendSearchParams([]);
    } else {
      setExtendSearchParams([data]);
    }

    // self.search();
  }

  //仅显示未发送订单
  function handleNotPublish(event) {
    handleReset();
    setOnlyShowUnPublish(event.target.checked);
  }

  //仅显示未发送订单
  function handleOnlyMyself(event) {
    handleReset();
    setOnlyMyself(event.target.checked);
  }

  function dateQueryRangeTypeChange(e) {
    let id = e.target.value;
    setDateQueryRangeType(id);
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* 自定义过滤项 */}
              {self.isPurchase && (
                <div className="fast-filter-box">
                  {!isOrderAutoPublish && (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={onlyShowUnPublish}
                          onChange={handleNotPublish}
                          value="checkedA"
                          color="primary"
                        />
                      }
                      labelPlacement="start"
                      label="未发送订单"
                    />
                  )}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={onlyMyself}
                        onChange={handleOnlyMyself}
                        value="checkedB"
                        color="primary"
                      />
                    }
                    labelPlacement="start"
                    label="我的订单"
                  />
                </div>
              )}

              <Select
                style={{
                  width: '100%',
                  marginLeft: '5px',
                  marginTop: '5px'
                }}
                value={dateQueryRangeType}
                onChange={e => dateQueryRangeTypeChange(e)}
              >
                {dateQueryRangeTypeList.map((item, index) => (
                  <MenuItem key={index} value={item.subKey}>
                    {item.subValue}
                  </MenuItem>
                ))}
              </Select>
            </div>
            {!self.isPurchase && customerList.length > 0 && (
              <div style={{ textAlign: 'center' }}>
                <FormControl style={{ marginRight: '10px', marginTop: '3px' }}>
                  <InputLabel htmlFor="extend-field">请选择客户</InputLabel>
                  <Select
                    style={{ width: '300px' }}
                    value={extendComapnyCode}
                    onChange={handleCustomerChange}
                    input={<Input id="extend-field" />}
                  >
                    {customerList.map((item, index) => (
                      <MenuItem key={index} value={item.customerCode}>
                        <ListItemText primary={item.text} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}
            <ExtendFields
              orgCompanyCode={extendComapnyCode}
              extendSearchParams={extendSearchParams}
              isPurchase={self.isPurchase}
              onComplete={data => {
                extendSeach(data);
              }}
            ></ExtendFields>
            <div className="list-total">{total}</div>
            {/* 列表项 */}
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.poXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.poErpNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                self.isPurchase
                                  ? 'B02_NPo_Status'
                                  : 'B02_NCPo_Status',
                                item.orderStatus
                              )
                            }
                          >
                            {item.orderStatusName}
                          </span>
                        </div>
                      </div>
                      <ul
                        className={
                          'field-list ' + (onlyShowUnPublish ? 'gray' : '')
                        }
                      >
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>订单日期</label>
                          <div>{formatDate(item.erpPurchaseDate)}</div>
                        </li>
                        <li>
                          <label>订单金额</label>
                          <div>
                            {item.isContainTax
                              ? formatNumber(
                                  item.productTaxTotal,
                                  item.Amount_Decimal_Place
                                )
                              : formatNumber(
                                  item.productTotal,
                                  item.Amount_Decimal_Place
                                )}
                          </div>
                        </li>
                        {self.isPurchase && item.receiveStatusName && (
                          <li>
                            <label>收货状态</label>
                            <div>
                              <span
                                className={
                                  'u-sign ' +
                                  (item.publishStatus === 0
                                    ? ''
                                    : item.receiveStatus === 0
                                    ? 'orange'
                                    : 'green')
                                }
                              >
                                {item.receiveStatusName}
                              </span>
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && item.deliveryStatusName && (
                          <li>
                            <label>送货状态</label>
                            <div>
                              <span
                                className={
                                  'u-sign ' +
                                  (item.deliveryStatus === 0
                                    ? 'orange'
                                    : 'green')
                                }
                              >
                                {item.deliveryStatusName}
                              </span>
                            </div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

OrderList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(OrderList);
